// extracted by mini-css-extract-plugin
export default {"container":"WithdrawCandicacy_container__Ro1VY","title":"WithdrawCandicacy_title__a2ZT3","consent":"WithdrawCandicacy_consent__enh7Z"};